import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import useStyles from './styles';

const Feature = ({ header, title }) => {
	const classes = useStyles();

	return (
		<Box p={2} className={classes.root}>
			<Box textAlign="center" className={classes.header}>
				{header}
			</Box>
			<Box pt={1}>
				<Typography
					variant="subtitle1"
					align="center"
					className={classes.title}
				>
					{title}
				</Typography>
			</Box>
		</Box>
	);
};

Feature.propTypes = {
	header: PropTypes.node,
	title: PropTypes.string
};

export default Feature;
